import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { ProgramInfoResponse } from 'src/types/view_catalogs/programInfo';
import axiosInstance from 'src/utils/axios';

async function fetchProgramInfo(catalogProgramId: string): Promise<ProgramInfoResponse> {
  const res = await axiosInstance.get<ProgramInfoResponse>(api.programInfo(catalogProgramId));
  return res.data;
}

const useGetProgramInfo = (catalogProgramId: string | null) =>
  useQuery<ProgramInfoResponse>({
    queryKey: queryKeys.marketplaceCategories.programInfo(catalogProgramId ?? ''),
    queryFn: () => fetchProgramInfo(catalogProgramId!),
    enabled: catalogProgramId !== null,
  });

export default useGetProgramInfo;
